export default function (state, payload) {
  return {
    ...state,
    ressourcenPlan: payload,
  }
}
